import React from 'react';
import {
  FormControl
} from 'react-bootstrap';
import SearchBoxLayout from './SearchBoxLayout.jsx';
import PromiseDelayer from '../PromiseDelayer.js';
import PropTypes from 'prop-types';
import {getPassthroughProps} from '../componentHelpers.js';

const updateDelayMs = 500;

/**
 * @deprecated Use SimpleSearchBar instead. Will be removed in v2.0.0
 */
class SearchBox extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      term: props.value,
    };

    this._updateDelayer = new PromiseDelayer(updateDelayMs);

    console.warn("SearchBox has been deprecated. Please use SimpleSearchBar instead.");
  }

  componentDidUpdate(prevProps) {
    if (this.props.value !== prevProps.value) {
      this.updateTerm({
        term: this.props.value,
      });
    }
  }

  updateTerm({term, notify}) {
    if (this.props.value === term) {
      return;
    }

    this.setState({ term: term });

    switch(notify) {
    case 'now':
      this.props.onChange(term);
      break;

    case 'when-settled':
      this._updateDelayer.run(() => this.props.onChange(term))
        .then(null, this._updateDelayer.swallowOwnRejections);
      break;
    }
  }

  render() {
    return (
      <SearchBoxLayout
        value={this.state.term}
        onChange={x => this.updateTerm({
          term: x.target.value,
          notify: 'when-settled',
        })}
        onClear={() => this.updateTerm({
          term: '',
          notify: 'now',
        })}
      />
    );
  }
}

SearchBox.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func
};

export default SearchBox;
